import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Icon from 'svg-inline-react'
import { Button } from '@driftt/tide-core-legacy'
import * as PresenceActions from 'app/modules/presence/actions'
import * as EndUserActions from 'app/modules/endUser/actions'
import { selectors } from 'app/modules/presence'
import CHAT_ICON_SRC from '!svg-inline?removeTags=true!images/svg/comment.svg'

class ChatButton extends Component {
  render() {
    const { usersWithMessageSent, endUserId } = this.props

    if (usersWithMessageSent.includes(endUserId)) {
      return <Button id="presence_chat" type="tertiary" onClick={this.setSelectedUser} className="sent-message"><Icon
        src={CHAT_ICON_SRC}/> Sent</Button>
    } else {
      return <Button className="sent-message" id="presence_chat" type="tertiary" onClick={this.setSelectedUser}>Chat</Button>
    }
  }
}

const makeMapStateToProps = () => {
  return (state) => {
    return {
      usersWithMessageSent: selectors.usersWithMessageSent(state)
    }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchEndUser: EndUserActions.fetchEndUser,
    bootstrapUser: PresenceActions.bootstrapUser
  }, dispatch),
})

export default connect(makeMapStateToProps, mapDispatchToProps)(ChatButton)



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/ChatButton/index.js